import React from 'react';

import { directTreasuryProductsQuery } from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getDirectTreasuryFilters, tableHead } from './constants';
import ProductItem from './item';

export const DirectTreasuryTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={directTreasuryProductsQuery}
      productsFiltersGetter={getDirectTreasuryFilters}
      tableHeadItems={tableHead}
      tabletColumns={3}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'assetNormalized', label: 'Ativo' },
        { key: 'positionDateNormalized', label: 'Data da posição' },
        { key: 'maturityDateNormalized', label: 'Data de vencimento' },
        { key: 'quantity', label: 'Quantidade' },
        { key: 'positionValueNormalized', label: 'Valor bruto' },
      ]}
    />
  );
};
